import {extractRequestContext, trackEvent} from '@/helpers/mixpanel.server';
import {createFileRoute, redirect} from '@tanstack/react-router';
import {createServerFn} from '@tanstack/react-start';
import {getRequest} from '@tanstack/react-start/server';

/**
 * Tracks a QR code scan event server-side with all query parameters
 * and request context (IP, user-agent, UTM params).
 */
const trackQrScan = createServerFn({method: 'GET'}).handler(async () => {
  const request = getRequest();
  if (!request) return;

  const requestContext = extractRequestContext(request);
  const url = new URL(request.url);
  const queryParams = Object.fromEntries(url.searchParams);

  await trackEvent(
    crypto.randomUUID(),
    'qr_code_scanned',
    queryParams,
    requestContext,
  );
});

export const Route = createFileRoute('/qr')({
  beforeLoad: async () => {
    await trackQrScan();
    throw redirect({to: '/', statusCode: 302});
  },
});
